import React, { memo } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Button from "../Common/Button";
import DividerLine from "./DividerLine";
import ReviewModal from "./ReviewModal";
import { getUserInformation } from "../../store/userRole";
import { useSelector } from "react-redux";
import FiChevronUp from "../../constants/icons/Fi/FiChevronUp";
import FiChevronDown from "../../constants/icons/Fi/FiChevronDown";

const Footer = ({
  currentQuestionIndex,
  openReviewModal,
  reviewModalOpen,
  closeReviewModal,
  goToPreviousQuestion,
  goToNextQuestion,
  currentSectionIndex,
  examData,
  markedQuestions,
  userAnswers,
  reviewMode,
  failAttempt = false,
}) => {
  const userInformation = useSelector(getUserInformation);

  const currentSectionQuestions =
    examData?.sections[currentSectionIndex]?.questions;
  const isFirstQuestion = currentQuestionIndex === 0;
  const totalQuestions =
    examData?.sections[currentSectionIndex]?.questions.length;
  return (
    <Container
      fluid
      style={{
        position: "fixed",
        bottom: "0px",
        left: 0,
        right: 0,
        backgroundColor: "#e6edf8",
        zIndex: 1,
        paddingBottom: "10px",
      }}
    >
      <Row className={`align-items-center px-5`}>
        <Col xs={12}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginBottom: "10px",
            }}
          >
            <DividerLine />
          </div>
        </Col>
        <Col sm={12} md={4}>
          <h5>{userInformation?.fullName}</h5>
        </Col>
        <Col
          sm={12}
          md={4}
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div onClick={openReviewModal} style={{ cursor: "pointer" }}>
            <div
              style={{
                width: 200,
                height: 40,
                background: "#1D1F1F",
                borderRadius: 7,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  width: 200,
                  textAlign: "center",
                  color: "white",
                  fontSize: 16,
                  fontFamily: "Inter",
                  fontWeight: "500",
                  wordWrap: "break-word",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 4,
                }}
              >
                <span>
                  Question {currentQuestionIndex + 1} of {totalQuestions}
                </span>
                <span style={{ marginLeft: 4, display: "inline-flex" }}>
                  {reviewModalOpen ? <FiChevronUp /> : <FiChevronDown />}
                </span>
              </div>
            </div>
          </div>
          {reviewModalOpen && !failAttempt && (
            <div
              style={{
                position: "fixed",
                top: "calc(100vh - 495px)",
                left: 0,
                width: "100vw",
                height: "100vh",
                zIndex: 1050,
              }}
              onClick={closeReviewModal}
            >
              <ReviewModal
                reviewModalOpen={reviewModalOpen}
                closeReviewModal={closeReviewModal}
                currentSectionIndex={currentSectionIndex}
                sectionQuestions={currentSectionQuestions}
                examData={examData}
                markedQuestions={markedQuestions}
                userAnswers={userAnswers}
                currentQuestionIndex={currentQuestionIndex}
                reviewMode={reviewMode}
              />
            </div>
          )}
        </Col>
        <Col
          sm={12}
          md={4}
          style={{
            display: "flex",
            justifyContent: "end",
          }}
        >
          <div>
            {!isFirstQuestion && (
              <Button
                variant="contained"
                style={{
                  backgroundColor: "#314CC6",
                  color: "white",
                  borderRadius: "20px",
                  marginRight: "10px",
                  padding: "8px 36px",
                  minWidth: "80px",
                }}
                onClick={goToPreviousQuestion}
              >
                Back
              </Button>
            )}
            <Button
              variant="contained"
              style={{
                backgroundColor: "#314CC6",
                color: "white",
                borderRadius: "20px",
                marginRight: "10px",
                padding: "8px 36px",
                minWidth: "80px",
              }}
              onClick={goToNextQuestion}
            >
              Next
            </Button>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default memo(Footer);
